import api from '../api'

export default {

  permissions: async () => {
    return api.get('api/permissions')
  },

  create: async role => {
    return api.post('api/permissions', { name: role })
  },

  get: async id => {
    return api.get('api/permissions/' + id)
  },

  update: async (id, role) => {
    return api.put('api/permissions/' + id, role)
  },

  delete: async id => {
    return api.delete('api/permissions/' + id)
  }
}
